import React from "react";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import Column from "@amzn/meridian/column";
import Responsive from "@amzn/meridian/responsive";
import { SMALL } from "../common/constant/BreakPoints";

const MetricViewV2 = (props) => {
  return (
    <Responsive
      query="max-width"
      props={{
        headerFontScale: {
          default: "h100",
          [SMALL]: "b100",
        },
        numberFontScale: {
          default: "d50",
          [SMALL]: "d50",
        },
      }}
    >
      {({ headerFontScale, numberFontScale }) => (
        <Column spacing="small">
          <Text type={headerFontScale}>
            <b>
              <FormattedMessage
                id={props.data.title}
                defaultMessage={props.data.message}
              />
            </b>
          </Text>
          <Text type={numberFontScale}>{props.data.value}</Text>
        </Column>
      )}
    </Responsive>
  );
};

export default MetricViewV2;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/MetricViewV2.js